import { Box } from '@mui/system';
import {Tab, Tabs, Typography, useTheme} from '@mui/material';

/**
 * Wrapper around MUI <Tabs> component, that handles the situation where only one tab is visible.
 */
const TabList = ({ tabs, currentTab, onChange }) => {
  const theme = useTheme();

  // For a11y reasons, when there is only one tab available, render a heading tag instead,
  // and don't use role="tablist"
  if (tabs.length === 1) {
    return (
      <Box sx={{mt: '36px'}}>
        <Typography
          variant="h2"
          sx={{
            borderBottom: `2px solid ${theme.palette.ilblue.main}`,
            color: theme.palette.ilblue.main,
            display: 'inline-block',
            fontFamily: 'SourceSans',
            fontWeight: 500,
            padding: '9px 16px',
            fontSize: '18px',
          }}
        >
          {tabs[0].label}
        </Typography>
      </Box>
    )
  }

  return (
    <Tabs
      value={currentTab}
      onChange={onChange}
      textColor="primary"
      indicatorColor="primary"
      sx={{
        marginTop: '32px',
        '.MuiButtonBase-root': {
          fontSize: '18px'
        }
      }}
    >
      {tabs.map(tab => (
        <Tab key={tab.name} label={tab.label} value={tab.name} data-cy={`tab-${tab.name}`}/>
      ))}
    </Tabs>
  );
}

export default TabList;
